<template>
<div class="yetki-page">

  <!-- TOOLBAR -->
  <div class="yetki-toolbar">
    <div class="yetki-title">
      <div class="yetki-title__label">Yetkilendirilen</div>
      <div class="yetki-title__name">{{aktif.tip + ' - ' + aktif.isim}}</div>
    </div>

    <div class="yetki-actions">
      <div class="yetki-search">
        <input type="text" v-model="search" placeholder="Müşteri ara..." />
      </div>

      <div class="yetki-count">
        Toplam: <b>{{ filteredList.length }}</b>
      </div>
    </div>
  </div>

  <!-- LIST -->
  <div class="yetki-list">
    <div
      v-for="(post, index) in filteredList"
      :key="post.guid || index"
      class="yetki-item"
      :class="post.yetki ? 'is-active' : 'is-passive'"
      @click="kayit(post,alias, index)"
    >
      <div class="yetki-item__left">
        <div class="yetki-item__name">{{ post.guid }}</div>
        <div class="yetki-item__sub">{{post.yetki ? 'Tıkla: yetkiyi pasif yap' : 'Tıkla: yetkiyi aktif yap'}}</div>


      </div>

      <div class="yetki-item__right">
        <span class="yetki-chip">
          {{ post.yetki ? 'AKTİF' : 'PASİF' }}
        </span>
      </div>
    </div>
  </div>

</div>

  </template>
  
  <script>
  import db from '../../db';

  export default {
  data() {
      return {
        posts:[],
        markas : [],
        hesap:this.$request.ayar(),
        //seciliKullanici:this.$store.getters.getKullanici,
        search:'',
        active:0,
        gruplar:[],
        aktif : JSON.parse(localStorage.getItem('aktifPersonel')),
        alias:this.$route.params.alan
      };
    },
    // },
    computed:{
      filteredList() {
        return this.posts.filter(post => {
          return post.guid.toLowerCase().includes(this.search.toLowerCase())
        })
      }    
    },
    async created() { 
      if (this.hesap.tip == 1) {
            const stocks = await db.stocks.toArray();
            const set = new Set();

            for (const s of (stocks || [])) {
            const g = s && s[this.alias] ? String(s[this.alias]).trim() : '';
            if (g) set.add(g);
            }

            this.gruplar = Array.from(set).sort().map(g => ({ guid: g, text: g }));
            this.$store.setLoading([false,''])
            this.getir();
      }
      else {
        this.$router.push("/info")
      }
    },
  
    methods: {
  
getir: function () {
  this.$store.setLoading([true, 'Bekleyin'])

  this.$request.post('crm/yetki/list/cari2', { kid: this.aktif.id, liste: this.gruplar,alias:this.alias })
    .then((res) => {
      if (res.status != 309) {
        // posts'u ata
        this.posts = res.data || []
        this.$store.setLoading([false, ''])
      } else {
            this.$router.push("/oturum")
      }
    })
    .catch((err) => {
      this.$store.setLoading([false, ''])
      this.$notify({ type: 'danger', message: err.message })
    })
}
,
      kayit(item,alias,index,index2){
        this.$store.setLoading([true,'Bekleyiniz'])
        let request = {
          kid :this.aktif.id,
          yid:item.guid,
          alias : alias,
          durum : item.yetki
        } 
        this.$request.post('crm/yetki',request).then(res=>{
          this.posts[index].yetki= res.durum
          this.$store.setLoading([false,''])
          this.$store.showNotify({ type: 'success', text: `Başarılı`, timeout: 1000 });

        }).catch((err)=>{
              this.$store.showNotify({ type: 'danger', text: `Tekrara Dene`, timeout: 1000 });
            this.$store.setLoading([false,''])
        }) 
      },
    },
  };
  </script>
  <style scoped>
.yetki-page{
  padding: 12px;
  background: #f6f7fb;
  min-height: 100%;
}

/* Toolbar */
.yetki-toolbar{
  background: #fff;
  border: 1px solid #e9ecf3;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.yetki-title__label{
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 2px;
}
.yetki-title__name{
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.yetki-actions{
  display: flex;
  align-items: center;
  gap: 10px;
}

.yetki-search{
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 8px 10px;
  min-width: 280px;
}
.yetki-search i{ color:#6b7280; }
.yetki-search input{
  border: 0;
  outline: 0;
  background: transparent;
  width: 100%;
  font-size: 14px;
}

.yetki-count{
  background:#111827;
  color:#fff;
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 13px;
}

/* List */
.yetki-list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.yetki-item{
  background: #fff;
  border: 1px solid #e9ecf3;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  transition: transform .08s ease, box-shadow .08s ease;
}

.yetki-item:hover{
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(17,24,39,0.08);
}

/* Sol durum çizgisi */
.yetki-item:before{
  content:'';
  position:absolute;
  left:0;
  top:0;
  bottom:0;
  width: 6px;
  border-radius: 12px 0 0 12px;
  background: #9ca3af;
}

.yetki-item.is-active:before{ background: #16a34a; }
.yetki-item.is-passive:before{ background: #ef4444; }

.yetki-item__name{
  font-size: 15px;
  font-weight: 650;
  color:#111827;
}
.yetki-item__sub{
  font-size: 12px;
  color:#6b7280;
  margin-top: 3px;
}

.yetki-chip{
  display:inline-block;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .2px;
}

.yetki-item.is-active .yetki-chip{
  background: rgba(22,163,74,.12);
  color: #15803d;
  border: 1px solid rgba(22,163,74,.25);
}

.yetki-item.is-passive .yetki-chip{
  background: rgba(239,68,68,.12);
  color: #b91c1c;
  border: 1px solid rgba(239,68,68,.25);
}

/* Responsive */
@media (max-width: 768px){
  .yetki-toolbar{ flex-direction: column; align-items: stretch; }
  .yetki-actions{ width:100%; }
  .yetki-search{ min-width: 0; width:100%; }
  .yetki-count{ width: fit-content; }
}

  </style>
  
  


// WEBPACK FOOTER //
// src/views/stok/yetki.vue